import { createReducer, on } from '@ngrx/store';
import { MasterStatusViewActions } from '../../create-request/actions';
import { MasterTransactionsTableActions } from '../../create-request/actions';
import { masterTransactionsState } from '../models/master-status-view/MasterTransactionsState';

export const masterTransactionsKey = 'masterTransactions';

export interface State extends masterTransactionsState { }

export const initialMasterTransactionsState: State = {
    transactions: [],
    isBookmarkFilterOn: false
}

export const masterTransactionsReducer = createReducer(
    initialMasterTransactionsState,
    on(MasterStatusViewActions.getMasterTransactionsList, (state) => {
        return {
            ...initialMasterTransactionsState
        }
    }),
    on(
        MasterStatusViewActions.callTransactionsSuccess, 
        MasterStatusViewActions.callBookmarkedAccountsSuccess, 
        (state, response) => {
        return {
            ...state,
            transactions: response.data
        }
    }),
    on(
        MasterTransactionsTableActions.currentTabUpdated,
        MasterStatusViewActions.getBookmarkedAccounts,
        (state) => {
        return {
            ...state,
            transactions: []
        }
    }),
    on(
        MasterStatusViewActions.getMasterTransactionsList,
        MasterTransactionsTableActions.currentTabUpdated,
        (state) => {
        return {
            ...state,
            isBookmarkFilterOn: false,
        }
    }),
    on(
        MasterStatusViewActions.getBookmarkedAccounts,
        (state) => {
        return {
            ...state,
            isBookmarkFilterOn: true,
        }
    }),
    on(
        MasterTransactionsTableActions.hasEmptyResponse,
        (state) => {
            return {
                ...state,
                transactions: []
            }
        }
    )

)
